











import {Component, Prop, Vue} from "vue-property-decorator";

export interface Product {
    size: number;
    unit: string;
    image: string;
    link: string;
}

@Component({})
export default class Products extends Vue {
    @Prop({
        type: Array,
        required: true
    })
    private products!: Product[];
}
